package navigation.home.suppliers

import navigation.home.suppliers.addeditsupplier.AddEditSupplierScreenModel
import navigation.home.suppliers.allsuppliers.AllSuppliersScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val supplierUiModule
    get() =
        module {
            factoryOf(::AllSuppliersScreenModel)
            factoryOf(::AddEditSupplierScreenModel)
        }
